export const routeNames = {
    dashboardRoutes:[
        'dashboard'
    ],
    masterRoutes:[
        'adminList',
        'adminCreate',
        'adminDetail',
        'adminEdit',
        'periodList',
        'periodCreate',
        'periodEdit',
        'gradeList',
        'gradeCreate',
        'gradeEdit',
        'holidayList',
        'holidayCreate',
        'holidayEdit',
        'holidayDetail',
        'paymentMethodList',
        'paymentMethodCreate',
        'paymentMethodDetail',
        'paymentMethodEdit',
        'teacherTypeList',
        'teacherTypeCreate',
        'teacherTypeEdit',
        'teacherTypeDetail',
        'appFormList',
        'appFormCreate',
        'appFormItems',
        'appFormDetail',
        'appFormEdit',
        'appFormEditItems'
    ],
    gradeRoutes : [
        'campusGradeList',
        'campusGradeCreate',
        'campusGradeEdit',
        'gradeFeeList',
        'gradeFeeCreate',
        'gradeFeeEdit',
        'gradeFeeDetail',
        'timetableMetaList',
        'timetableMetaCreate',
        'timetableMetaDetail',
        'timetableMetaEdit',
        'timetableList',
        'timetableCreate',
        'timetableDetail',
        'timetableEdit',
        'classList',
        'classCreate',
        'classEdit',
        'classDetail',
        'subjectList',
        'subjectCreate',
        'subjectEdit',
        'subjectDetail',
    ],
    teacherRoutes: [
        'teacherList',
        'teacherEdit',
        'teacherCreate',
        'teacherProfile',
        'attendanceTeacherList',
        'attendanceTeacherDetail',
        'attendanceTeacherEdit',
        'attendanceTeacherCreate',
        'subjectTeacher',
        'subjectTeacherList',
        'subjectTeacherCreate',
        'subjectTeacherEdit',
        'subjectTeacherDetail',
        'courseList',
        'courseCreate',
        'courseEdit',
        'courseDetail',
        'ChatMessageHistory',
        'chatRequestList',
        'assignmentList',
        'assignmentCreate',
        'assignmentEdit',
        'assignmentDetail',
    ],
    studnetRoutes:[
        'parentList',
        'parentCreate',
        'parentEdit',
        'parentDetail',
        'studentList',
        'studentEdit',
        'studentPass',
        'studentFail',
        'studentCreate',
        'studentProfile',
        'examList',
        'examCreate',
        'examDetail',
        'examEdit',
        'gradingList',
        'gradingCreate',
        'gradingDetail',
        'gradingEdit',
        'gradingImport',
        'attendanceStudentList',
        'attendanceStudentDetail',
        'attendanceStudentEdit',
        'attendanceStudentCreate',
        'attendanceRateList',
        'applicantList',
        'applicantDetail'
    ],
    financeRoutes: [
        'itemList',
        'itemCreate',
        'itemDetail',
        'itemEdit',
        'paymentRequestList',
        'paymentRequestDetail',
        'paymentList',
        'paymentCreate',
        'paymentDetail',
        'paymentEdit',
        'paymentCheckout',
        'transactionList',
        'transactionCreate',
        'transactionDetail',
        'transactionEdit',
        'salaryList',
        'salaryCreate',
        'salaryEdit',
        'salaryDetail',
    ],
    ferryRoutes: [
        'driverList',
        'driverCreate',
        'driverEdit',
        'driverDetail',
        'ferryCreate',
        'ferryList',
        'ferryEdit',
        'ferryDetail',
        'routeList',
        'routeCreate',
        'routeEdit',
        'routeDetail',
        'ferryPickupList',
        'ferryPickupDetail',
        'ferryPickupEdit',
        'dailyFerryList',
        'dailyFerryCreate',
        'dailyFerryEdit',
        'dailyFerryDetail',
    ],
    libraryRoutes: [
        'bookList',
        'bookCreate',
        'bookDetail',
        'bookEdit',
        'libraryMemberList',
        'libraryMemberCreate',
        'libraryMemberDetail',
        'libraryMemberEdit',
        'checkoutList',
        'checkoutCreate',
        'checkoutDetail',
        'checkoutEdit',
        'damageLossesList',
        'damageLossesCreate',
        'damageLossesDetail',
        'damageLossesEdit',
        'categoryItems',
    ],
    noticeRoutes:[
        'noticeList',
        'noticeCreate',
        'noticeDetail',
        'noticeEdit',
        'leaveList',
        'leaveCreate',
        'leaveEdit',
        'leaveDetail'
    ],
    reportRoutes:[
        'transactionReport',
        'PassPercentage',
    ]
};
